import React, { createContext, useState, useEffect, useContext } from "react";
import { defaultLanguage } from "../Config/Consts";
import { useHistory } from "react-router";
import { reportService } from "../Services/report.service";
import { AuthContext } from "./AuthContext";

const SELECTED_LANGUAGE_ID = "SELECTED_LANGUAGE_ID";

export const GlobalContext = createContext();

export const GlobalContextProvider = (props) => {
  const [globalState, setGlobalState] = useState({
    selectedLanguageId:
      localStorage.getItem(SELECTED_LANGUAGE_ID) || defaultLanguage,
    isActiveMenu: true,
    updatedResource: null,
  });

  const history = useHistory();
  const { token } = useContext(AuthContext);
  const [locTenant, setLocTenant] = useState();
  const [locName, setLocName] = useState();
  const [locStore, setLocStore] = useState();
  const [locPos, setLocPos] = useState();
  const [locTab, setLocTab] = useState();
  const [locUser, setLocUser] = useState();
  const [locKey, setLocKey] = useState();
  const [isMobile, setIsMobile] = useState(false);
  const [updatePerformances, setUpdatePerformances] = useState(new Date());

  const [showUnfBilToast, setShowUnfBilToast] = useState(false);
  const [unfiscalizedBillCount, setUnfiscalizedBillCount] = useState(0);
  const [updateToast, setUpdateToast] = useState(new Date());

  useEffect(() => {
    setLocTenant(sessionStorage.getItem("locTenant"));
    setLocName(sessionStorage.getItem("locName"));
    setLocStore(sessionStorage.getItem("locStore"));
    setLocPos(sessionStorage.getItem("locPos"));
    setLocTab(sessionStorage.getItem("locTab"));
    setLocUser(sessionStorage.getItem("locUser"));
    setLocKey(sessionStorage.getItem("locKey"));

    if (window.innerWidth < 940) {
      setIsMobile(true);
    }
  }, []);

  useEffect(() => {
    reportService
      .invoicesTotalUnfiscal(Number(localStorage.getItem("tenantId")), token)
      .then((res) => {
        const totalCount = res.data.totalNumber;
        setUnfiscalizedBillCount(totalCount);
        setShowUnfBilToast(totalCount > 0 ? true : false);
      })
      .catch((err) => console.log(err));
  }, [updateToast]);

  // useEffect(() => {
  //   console.log('locTenant', locTenant);
  // }, [locTenant]);

  const changeLanguage = (languageId) => {
    localStorage.setItem(SELECTED_LANGUAGE_ID, languageId);
    setGlobalState({ ...globalState, selectedLanguageId: languageId });
    history.go(0);
  };

  const updateTranslation = ({ languageId, key, value }) => {
    setGlobalState({
      ...globalState,
      updatedResource: { languageId, key, value },
    });
  };

  const toggleMenu = () => {
    setGlobalState({
      ...globalState,
      isActiveMenu: !globalState.isActiveMenu,
    });
    setUpdatePerformances(new Date());
  };

  const updateLocName = (name) => {
    setLocName(name);
    sessionStorage.setItem("locName", name);
  };

  const updateLocTenant = (tenant) => {
    setLocTenant(tenant);
    sessionStorage.setItem("locTenant", Number(tenant));
  };
  const updateLocStore = (store) => {
    setLocStore(store);
    sessionStorage.setItem("locStore", Number(store));
  };
  const updateLocPos = (pos) => {
    setLocPos(pos);
    sessionStorage.setItem("locPos", Number(pos));
  };
  const updateLocTab = (tab) => {
    setLocTab(tab);
    sessionStorage.setItem("locTab", tab);
  };

  const updateLocUser = (user) => {
    setLocUser(user);
    sessionStorage.setItem("locUser", user);
  };
  const updateLocKey = (user) => {
    setLocUser(user);
    sessionStorage.setItem("locKey", user);
  };

  return (
    <GlobalContext.Provider
      value={{
        ...globalState,
        locName,
        locTenant,
        locStore,
        locPos,
        locTab,
        locUser,
        locKey,
        isMobile,
        changeLanguage,
        updateTranslation,
        toggleMenu,
        updateLocName,
        updateLocTenant,
        updateLocStore,
        updateLocPos,
        updateLocTab,
        updateLocUser,
        updateLocKey,
        updatePerformances,
        setUpdatePerformances,
        unfiscalizedBillCount,
        showUnfBilToast,
        setShowUnfBilToast,
        setUpdateToast,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
